import React from 'react'
import Prototype from '../features/prototype'

console.log("PrototypePage.jsx");

function PrototypePage() {
  return (
    <Prototype />
  )
}

export default PrototypePage